export default __webpack_public_path__ + "static/media/vi_Vallenato.0ec2bd62.mp4";